
import { computed, defineComponent, onMounted, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { patientApi } from '@/shared/api'
import PeriodontalMap from '@/pages/PeriodontalPage/components/PeriodotalMap.vue'
import { WConsolidatedReport } from '@/widgets/WConsolidatedReport'
import { useUser } from '@/shared/composables'
import {
  CommentType,
  ConsolidatedDataType,
  ConsolidatedTableType,
  PatientType,
  PeriodontalDetailType,
  PeriodontalReportType,
} from '@/shared/types'
import { getDateFormat, showErrorMessage } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'

export default defineComponent({
  name: 'PeriodontalPreview',
  components: {
    PeriodontalMap,
    WConsolidatedReport,
  },

  props: {
    reportInfo: Object as PropType<PeriodontalDetailType>,
    data: Object as PropType<PeriodontalReportType>,
    plaque: Number,
    bleeding: Number,
    suppuration: Number,
    pockets: Number,
    pocketsTable: Array as PropType<ConsolidatedTableType[]>,
    comments: Array as PropType<CommentType[]>,
    consolidatedData: Object as PropType<ConsolidatedDataType>,
  },

  setup(props) {
    const route = useRoute()

    const { user } = useUser()

    const patientInfo = ref<PatientType>({
      cart_number: '',
      date: '',
      id: 0,
      name: '',
      email: '',
      patronymic: '',
      phone: '',
      surname: '',
    })

    const date = computed((): string =>
      props.reportInfo.date_at
        ? getDateFormat(new Date(props.reportInfo.date_at), DATE_FORMAT.dmyLong)
        : ''
    )

    const logo = computed(() => {
      let domain = window.origin

      if (process.env.NODE_ENV === 'production') {
        domain = process.env.VUE_APP_BASE_URI
      }

      return user.value.organization.logo
        ? `${domain}/api/web/admin/reports/storage/${user.value.organization.logo.id}`
        : ''
    })

    const patientId = computed((): string | string[] => route.params.patientId)
    const birthday = computed(() => patientInfo.value.date)

    const lastComment = computed(
      (): CommentType => props.comments[props.comments.length - 1]
    )

    const getPatientInfo = async (): Promise<void> => {
      const [error, response] = await patientApi.getPatientInfo(
        Number(patientId.value)
      )

      if (error) {
        showErrorMessage(error)
      } else {
        patientInfo.value = response.data.patient
      }
    }

    onMounted((): void => {
      getPatientInfo()
    })

    return {
      patientInfo,
      date,
      logo,
      birthday,
      lastComment,
    }
  },
})
